import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import { isSeriesOvertime } from "../../utils/overtime-utils";

/**
 * An overtime coin toss that counts. Gate only for what the ball does next:
 * the children decide between a series (OvertimeOpensWithDrive) and a
 * kickoff (OvertimeOpensWithKickoff, PSTATS-1268).
 *
 * Series overtime keeps its one rule: the toss counts in the first overtime
 * period. With OT Kickoffs on, only the toss the first overtime period
 * requires counts; any other is recorded and changes nothing.
 */
export default class CoinToss extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        if (fragment.associatedState !== FootballState.CoinToss) {
            return false;
        }

        const otPeriod = gameContext.getOvertimePeriod();
        if (!otPeriod || isSeriesOvertime(gameContext)) {
            return otPeriod === 1;
        }

        return !!gameContext.coinTossRequired;
    }

    async apply(gameContext) {
        gameContext.setCoinTossRequired(false);
    }
}
